// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__iIayK","name":"Header_name__2at--","birthday":"Header_birthday__S_Che","skeleton":"Header_skeleton__znYQF"};